// The onSubmit handler can return either void or Promise<void | T>, which triggers
// the no-misused-promises rule when passed to form.handleSubmit. This is a false positive
// since react-hook-form properly handles both synchronous and asynchronous submit handlers.
/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { FormProvider } from 'react-hook-form';
import { FormProps } from '../../../types/fileExplorerTypes';
import { EditFolderSchema, FolderRenameSchema } from './schemas';
import { CheckboxField, InputField } from '../../Forms/Fields';
import { FolderOptions } from './constants';

export function EditFolderForm({
  form, onSubmit, children, ...rest
}: FormProps<EditFolderSchema>) {
  return (
    <FormProvider {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className="modal-form" {...rest}>
        <InputField<FolderRenameSchema>
          id="name"
          path="name"
          label="Nombre"
          placeholder="Nombre de la carpeta"
          required
        />
        <InputField<EditFolderSchema>
          id="description"
          path="description"
          label="Descripción"
          placeholder="Descripción de la carpeta"
        />

        <CheckboxField<EditFolderSchema>
          label="Remover prefijo de archivos directos de esta carpeta"
          options={FolderOptions.asCheckboxOptions({ options: ['remove_file_prefix'] })}
          orientation="horizontal"
          pathsMap={{
            remove_file_prefix: 'remove_file_prefix',
          }}
        />
        {children}
      </form>
    </FormProvider>
  );
}
